// extracted by mini-css-extract-plugin
module.exports = {"section":"section___3jtZY","isCentered":"isCentered___kokeR","title":"title___3RPQx","subtitle":"subtitle___D-b-d"};